import React from "react";
import { useNavigate } from "react-router";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { resetFilter, threatNameFiltered, threatTypeFiltered, } from "../../../store/malwareSlice";
import { Malware } from "../../../ui";
import { LinkToReportTab } from "../../common";
import { useReportDispatch } from "../../hooks";
const MalwareContainer = ({ detections, }) => {
    const dispatch = useReportDispatch();
    const navigate = useNavigate();
    const totalMalware = detections.type.reduce((acc, threatType) => acc + threatType.total_count, 0);
    return (React.createElement(Malware.Panel, { helperText: React.createElement(LinkToReportTab, { id: "All malware", to: REPORT_PAGES_ROUTES.MALWARE_ROUTE, color: "link", onClick: () => dispatch(resetFilter()) },
            "All malware (",
            totalMalware.toLocaleString(),
            ")") },
        React.createElement(Malware.MostSevereThreats, { detections: detections, threatNameWrapper: (result, children) => (React.createElement(LinkToReportTab, { id: `${result} Details`, to: REPORT_PAGES_ROUTES.MALWARE_ROUTE, color: "link", onClick: () => dispatch(threatNameFiltered({ threat_name: result, hide_triaged: true })) }, children)) }),
        React.createElement(Malware.CategoryBars, { detections: detections, onBarClick: (threatType) => {
                dispatch(threatTypeFiltered({ threat_type: threatType, hide_triaged: true }));
                navigate(REPORT_PAGES_ROUTES.MALWARE_ROUTE);
            } })));
};
export default MalwareContainer;
//# sourceMappingURL=Malware.js.map